import Title from "@/shared/components/report-template/presentation/components/common/Title";
import ReportTemplate from "@/shared/components/report-template/presentation/components/ReportTemplate";
// @ts-ignore
import image from "@assets/images/cropping-pattern/definition-cropping.png";

const CroppingPatternDefinition = () => {
  return (
    <ReportTemplate serviceType="CROPPING_PATTERN" pageNumber={1} reportCode="">
      <div className="w-full flex flex-col gap-6">
        <Title>تعریف الگوی کشت</Title>

        <ul className=" list-disc list-inside flex flex-col gap-3">
          <li className="leading-[28px] !font-[B-Nazanin] text-[16px]">
            الگوی کشت به مفهوم نوع، سطح زیرکشت و زمان بندی مناسب کشت محصولات
            زراعی و باغی در یک منطقه مشخص، با درنظر گرفتن شرایط اقلیمی، منابع آب
            و خاک، توانمندی های اقتصادی و اجتماعی منطقه است. هدف اصلی از تدوین و
            اجرای الگوی کشت، بهره برداری بهینه و پایدار از منابع موجود، افزایش
            بهره وری، حفظ امنیت غذایی و کاهش آسیب های زیست محیطی ناشی از کشاورزی
            ناپایدار است.
          </li>
          <li className="leading-[28px] !font-[B-Nazanin] text-[16px]">
            با توجه به چالش‌هایی همچون محدودیت منابع آبی، تغییرات اقلیمی، نیاز
            به افزایش تولید در واحد سطح و ضرورت هماهنگی میان تولید و بازار مصرف،
            تدوین یک الگوی کشت علمی و منطقه‌محور از اهمیت فراوانی برخوردار است.
          </li>
        </ul>

        <div className="border-2 border-dashed border-president rounded-lg p-4 my-8 text-[18px] font-bold leading-[28px] !font-[B-Nazanin]">
          سامانه الگوی کشت با هدف تحلیل داده‌ها، پیشنهاد نوع محصولات مناسب برای
          کشت و کمک به تصمیم‌گیری بهتر کشاورزان طراحی شده است تا بستری برای
          مدیریت هوشمند و پایدار نظام تولید کشاورزی فراهم آورد.
        </div>
        <div className="w-full flex justify-center items-center">
          <div className="w-full h-[320px]">
            <img className="w-full h-full" src={image} alt="definition" />
          </div>
        </div>
      </div>
    </ReportTemplate>
  );
};

export default CroppingPatternDefinition;
